export default __webpack_public_path__ + "static/media/email.96a8138c.svg";